// extracted by mini-css-extract-plugin
export var cardSelected = "_dn-2";
export var image = "_dn-1";
export var table = "_dn-0";